import api from './api';
import { API_ENDPOINTS, USE_MOCK_DATA } from '../constants/config';
import { addMockCompany, getMockCompanies } from '../data/mockData';

class CompanyService {
  async getAllCompanies() {
    if (USE_MOCK_DATA) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({ success: true, data: getMockCompanies() });
        }, 300);
      });
    }

    try {
      const response = await api.get(API_ENDPOINTS.COMPANIES);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error fetching companies:', error);
      return { success: false, error: error.response?.data?.detail || error.message };
    }
  }

  async createCompany(companyData) {
    if (USE_MOCK_DATA) {
      return new Promise((resolve) => {
        setTimeout(() => {
          const result = addMockCompany(companyData?.company_name || '');
          resolve(result);
        }, 400);
      });
    }

    try {
      const response = await api.post(API_ENDPOINTS.COMPANIES, companyData);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error creating company:', error);
      return { success: false, error: error.response?.data?.detail || error.message };
    }
  }
}

export default new CompanyService();